module.exports = __webpack_public_path__ + "media/images/technology/lab-1-6daa06a71a2d791b849b2795778d2fc7.png";